import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
import { GetEnterpriseAccountListMessage, GetPersonAccountListMessage } from '../entity/account-list/account-list-message';
import { SwitchEnterpriseAccountMessage, SwitchPersonAccountMessage } from '../entity/account-switch/account-switch-message';
import { LogOutMessageEntity } from '../entity/logout-message/logout-message';
import { QQMessage } from '../entity/qq-message/qq-message-entity';
import { WeworkMessage } from '../entity/wework-message/wework-message';
/**
 * 目前只有QQ传过来的信息，只会根据业务增加
 */
var MessageDomainService = /** @class */ (function () {
    function MessageDomainService() {
        this.getEnterpriseAccountListMessage = new GetEnterpriseAccountListMessage();
        this.switchEnterpriseAccountMessage = new SwitchEnterpriseAccountMessage();
        this.getPersonAccountListMessage = new GetPersonAccountListMessage();
        this.switchPersonAccountMessage = new SwitchPersonAccountMessage();
        this.qqMessage = new QQMessage();
        this.weworkMessage = new WeworkMessage();
        this.logoutMessage = new LogOutMessageEntity();
    }
    /**
     * 初始化 Message 领域
     * 无需提供初始化方法，提供空实现
     */
    MessageDomainService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], MessageDomainService.prototype, "init", null);
    return MessageDomainService;
}());
export { MessageDomainService };
